module.exports = __webpack_public_path__ + "img/google-play-badge.98fc32f5.png";